/* eslint camelcase: 0 */
import { Checkbox } from "@newsela/angelou";

import { withTrackEvent, actionPrefixes, actionNames } from "@newsela/snitch";
import { Classroom } from "@/types/models/Assignment.interface";
import { errorBorderCss } from "../AssignmentOptions.style";
import { checkboxCss, ulCss } from "./WholeClassAssignmentOptions.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox) as typeof Checkbox;

type checkboxProps = React.ComponentPropsWithoutRef<typeof Checkbox>;
type onClickType = checkboxProps["onClick"];
export interface WholeClassAssignmentOption {
  allTeacherClassrooms: Classroom[];
  areAllClassroomsVisible: boolean;
  assignment: {
    assignment_classrooms: Classroom[];
  };
  hasError: boolean;
  onClick: onClickType;
}

export const WholeClassAssignmentOptions = ({
  allTeacherClassrooms,
  areAllClassroomsVisible,
  assignment,
  hasError,
  onClick,
}: WholeClassAssignmentOption) => {
  const INITIAL_VISIBLE_CLASSROOMS = 3;
  const { assignment_classrooms } = assignment;
  const initialVisibleClassrooms =
    allTeacherClassrooms?.length > INITIAL_VISIBLE_CLASSROOMS
      ? allTeacherClassrooms?.slice(0, INITIAL_VISIBLE_CLASSROOMS)
      : [];

  const determineIsChecked = (teacherClassroom: Classroom) => {
    const assignedClassroom: Classroom | undefined =
      assignment_classrooms?.find(
        (classroom) => classroom.unique_id === teacherClassroom.unique_id,
      );

    return assignedClassroom
      ? assignment_classrooms.includes(assignedClassroom)
      : false;
  };

  const classroomsToDisplay = areAllClassroomsVisible
    ? allTeacherClassrooms
    : initialVisibleClassrooms;

  return (
    <ul css={ulCss}>
      {classroomsToDisplay?.map((classroom) => {
        const isChecked = determineIsChecked(classroom);
        return (
          <li key={classroom.unique_id}>
            <CheckboxWithTrackEvent
              /* @ts-expect-error Property 'children' does not exist on type */
              actionName={actionNames.add}
              actionPrefix={actionPrefixes.initiate}
              checked={isChecked}
              dataProps={{
                "data-qa-selector": `whole classroom option ${classroom.name}`,
              }}
              label={classroom?.name}
              name="classroom"
              objectType="Assignment"
              onClick={(e) => (onClick ? onClick(e) : null)}
              streamProperties={{
                description: `assigns to ${classroom.name}`,
              }}
              value={classroom.unique_id}
              __cssFor={{
                root: [checkboxCss, hasError ? errorBorderCss : null],
              }}
              withContainer
            />
          </li>
        );
      })}
    </ul>
  );
};

export default WholeClassAssignmentOptions;
